import { useState } from 'react';

import { ActionToggle } from '@/components/form/ActionToggle';

import { State } from '../State';

export function ActionToggleExamples() {
  const [on, setOn] = useState(true);
  const [off, setOff] = useState(false);

  return (
    <>
      <State
        title="On"
        note="Saved the moment it is switched, so there is no Save button."
      >
        <ActionToggle
          label="Donate"
          hint="External fundraising link"
          checked={on}
          onChange={setOn}
          link={{ label: 'Manage Fundraising', to: '#' }}
          testId="gallery-action-toggle-on"
        />
      </State>

      <State title="Off">
        <ActionToggle
          label="Volunteer"
          hint="External volunteer form"
          checked={off}
          onChange={setOff}
          link={{ label: 'Manage Volunteers', to: '#' }}
          testId="gallery-action-toggle-off"
        />
      </State>

      <State
        title="Disabled"
        note="Read-only: staff viewing, or a suspended organization."
      >
        <ActionToggle
          label="Donate"
          hint="External fundraising link"
          checked
          onChange={() => {}}
          disabled
          testId="gallery-action-toggle-disabled"
        />
      </State>

      <State
        title="Saving"
        note="The new state shows at once while the save is on its way."
      >
        <ActionToggle
          label="Volunteer"
          hint="External volunteer form"
          checked
          onChange={() => {}}
          pending
          testId="gallery-action-toggle-pending"
        />
      </State>
    </>
  );
}
